import { useMutation } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { PaymentResult } from '@/types/dtos/transactions/response/payment-result.dto.ts';
import type { RequestOrderPaymentDto } from '@/types/dtos/transactions/request/request-order-payment.dto.ts';
import { useFeatureAccess } from '@/hooks/use-feature-access';
import { EVENT_CATALOG_ORDERS_FEATURE } from '@/constants/feature-flags';

export const useRequestOrderPaymentMutation = () => {
  const { getToken } = useAuth();
  const { hasAccess } = useFeatureAccess(EVENT_CATALOG_ORDERS_FEATURE);

  return useMutation({
    mutationFn: async (requestOrderPaymentDto: RequestOrderPaymentDto) => {
      if (!hasAccess) throw new Error('Event catalog orders are not available');
      const token = await getToken();
      return requestOrderPayment(requestOrderPaymentDto, token ?? '');
    },
  });
};

const requestOrderPayment = async (
  requestOrderPaymentDto: RequestOrderPaymentDto,
  token: string,
): Promise<PaymentResult> => {
  const { orderId, ...rest } = requestOrderPaymentDto;
  const url = `${import.meta.env.VITE_API_URL}/transactions/order/${orderId}`;
  return sendJSONRequest({ url, method: METHOD.POST, body: rest, token });
};
